import {Reducer} from "redux";
import {ClientEntriesState} from "../store/client_entries_state";
import {
    ClientEntriesAction,
    ClientEntriesActionType,
    ICallbackGetAllEntriesAction,
} from "../action/client_entries_action";


const initialState: ClientEntriesState = {
    entries: [],
    customers: [],
    contracts: [],
    project: null,
    isLoading: false,
};

const clientEntriesReducer: Reducer<ClientEntriesState> = (state = initialState, action: ClientEntriesAction): ClientEntriesState => {
    switch (action.type) {
        case ClientEntriesActionType.REQUEST_GET_ALL_ENTRY_LIST: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientEntriesActionType.CALLBACK_GET_ALL_ENTRY_LIST: {
            const _action = action as ICallbackGetAllEntriesAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    entries: _action.item ? _action.item.entries : [],
                    customers:  _action.item ? _action.item.customers : [],
                    contracts: _action.item ? _action.item.contracts : [],
                    project: _action.item ? _action.item.project : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }
        default:
            return state;
    }
};

export default clientEntriesReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_entries_reducer.ts